
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"view.filters.button.label":"Data view filters","d-analysis-context-panel.toggle":"Workbook filters"},"de":{"view.filters.button.label":"Datensichtfilter","d-analysis-context-panel.toggle":"Arbeitsmappenfilter"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();